// File: ProfileCardHeader.js
import React, { useState } from "react";
import { ClipboardList, Timer } from "lucide-react";
import { capitalizeWords } from "../../utils";
import { Tooltip } from "react-tooltip";

const ProfileCardHeader = ({ profile }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  return (
    <div className="border-b border-gray-200 bg-indigo-50 px-3 py-2.5 md:px-4 md:py-3 flex items-center justify-between gap-2">
      <h3 className="text-xs md:text-sm font-medium text-gray-900 truncate flex items-center min-w-0 flex-1">
        <ClipboardList className="h-4 w-4 mr-2 md:mr-3 text-indigo-600 flex-shrink-0" />
        <span className="truncate">{capitalizeWords(profile.basic.name)}</span>
        {!profile.approved ? (
          <Timer
            className="h-4 w-4 ml-2 md:ml-3 text-red-600 flex-shrink-0"
            data-tooltip-id={`promt_file_upload_tooltip_${profile._id}`}
            data-tooltip-content="Approval Pending"
            data-tooltip-place="bottom"
            onMouseEnter={() => setTooltipOpen(true)}
            onMouseLeave={() => setTooltipOpen(false)}
          />
        ) : (
          ""
        )}
        <Tooltip
          id={`promt_file_upload_tooltip_${profile._id}`}
          isOpen={tooltipOpen}
        />
      </h3>
      {profile.basic.is_default ? (
        <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 flex-shrink-0">
          Default
        </span>
      ) : (
        ""
      )}
    </div>
  );
};

export default ProfileCardHeader;
